<template>
	<div class="portcallberthsFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'portcallberths-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'portcallberths'
		};
	},
	computed: {
	}
}
</script>
